<div class="container-wrap" [formGroup]="parentFormGroup">
  @if (!bannerConfig.src) {
    <div class="row-wrap">
      <file-upload (fileChange)="fileChanged($event)" [parentFormGroup]="parentFormGroup"></file-upload>
    </div>
  }
  @if (!!bannerConfig.src) {
    <div class="row-wrap">
      <mat-form-field appearance="fill" class="banner-config-field">
        <mat-label>Banner URL</mat-label>
        <input matInput formControlName="src" [disabled]="true">
      </mat-form-field>
      <a mat-stroked-button (click)="toggleBannerPreview()" class="toggle-banner-preview">
      {{showBannerPreview ? 'Hide banner' : 'Show banner'}}</a>
    </div>
  }
  @if (!!bannerConfig.src && showBannerPreview) {
    <div class="row-wrap banner-preview">
      <img [src]="bannerConfig.src">
    </div>
  }
  <div class="row-wrap">
    <mat-form-field appearance="fill" class="banner-config-field">
      <mat-label>Banner name</mat-label>
      <input matInput formControlName="name" autocomplete="off">
    </mat-form-field>
    <app-selector-control [placeholderText]="'Select App'" class="banner-config-field" [controlName]="'appId'"
    [parentFormGroup]="parentFormGroup" [selectedAppId]="bannerConfig.appId"></app-selector-control>
  </div>

  <div class="row-wrap">
    <span class="label">Show banner for user role:</span>
    <div class="item">
      <mat-form-field appearance="fill" class="banner-config-field">
        <mat-select placeholder="Visibility" formControlName="visibility">
          <mat-option [value]="bannerVisibilityEnum.all">All</mat-option>
          <mat-option [value]="bannerVisibilityEnum.clinic">Clinic</mat-option>
          <mat-option [value]="bannerVisibilityEnum.lab">Lab</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row-wrap">
    <span class="label">Show banner in countries:</span>
    <div class="item">
      <country-selector [parentFormGroup]="parentFormGroup" controlName="availableInCountries"
      [placeholderText]="'Select list of countries'"></country-selector>
    </div>
  </div>

  <div class="row-wrap">
    <mat-form-field appearance="fill" class="banner-config-field">
      <mat-label>Link</mat-label>
      <input matInput formControlName="link" autocomplete="off">
    </mat-form-field>
  </div>

  <div class="row-wrap multi-control">
    <div class="column-wrap">
      <mat-form-field appearance="fill" class="item">
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" autocomplete="off">
        <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill" class="item">
        <mat-label>End date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" autocomplete="off">
        <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
      @if (parentFormGroup.hasError('startDateBiggerThanEnd')) {
        <mat-icon class="error-icon"
        matTooltip="Invalid date range">error</mat-icon>
      }
    </div>
  </div>
  <div class="controls">
    <button type="button" mat-raised-button color="primary" (click)="deleteBanner($event)" class="delete-banner-button">
      <mat-icon>delete_outline</mat-icon> Delete banner</button>
    </div>
  </div>
